import { gql } from '@apollo/client';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { configureApolloLogging } from '@fluentsms/graphql';
import { init } from '@fluentsms/i18n';
import { isUpperEnvironment } from '@fluentsms/utils';

// This warning is valid, but we want toavoid noisy console output in upper environments.
// configureApolloLogging must run before any Apollo hook renders: it silences Apollo's
// own dev-mode console diagnostics in eval and prod, where they would otherwise reach
// end users and FullStory recordings.
if (isUpperEnvironment()) {
  gql.disableFragmentWarnings();
  configureApolloLogging();
}

async function renderApp() {
  const { default: App } = await import('./App');
  const container = document.getElementById('root');
  if (!container) throw new Error('Root element not found');
  const root = createRoot(container);
  root.render(<App />);
}

/**
 * i18n must be initialized before any yup schema for yup integration to succeed
 * making App loadable after i18n.init the yup locale is defined before any schema defined
 */
init();

renderApp();
